
import React, { useState ,useEffect} from 'react';
import {useNavigate ,Link} from 'react-router-dom';
import {Row, Table} from 'antd';
import Title from 'antd/es/skeleton/Title';
import {  viewSurveyValidatedLowEac} from '../service/UserDetails';
import { render } from '@testing-library/react';
import Item from 'antd/es/list/Item';
import App from '../App';
import moment from 'moment';
import {Divider} from 'antd';

function SurveyValidatedLowEAC(){
    const navigator = useNavigate();
    const [user, setUser] = useState({ role: 'survey',});

    const handleClick = (record) => {
      const url = `/survey-create-lead/${record.id}?isEdit=true`;
      window.open(url, '_blank');
    };

  //   const handleClick = (record) => {
  //     
  //     // Construct the URL for navigation
  //     const url = `/survey-create-lead/${record.id}`;
  //    // const url = `/survey-create-lead/${record.id}?role=${user.role}`;
  //    // const url = `/survey-create-lead/${record.id}?role=${user.role}`;
  //     
  //     // Open the URL in a new tab
  //     window.open(url, '_blank');
  //     // Optionally, you can use navigate to pass state if needed
  //     // navigate(url, { 
  //     //     state: { 
  //     //         findUser: id,
  //     //         user: user, 
  //     //         isEdit: true 
  //     //     } 
  //     // });
  // };



  
const [dataSource, setDataSource]= useState([]) 



const callBackResponse = async () => {
        
   
    await viewSurveyValidatedLowEac()
    .then(res => 
     {
         
         const mappedData = res.data.data;
         
         setDataSource(mappedData);
     })
    .catch(err => 
     {
         
         if(err.response.data.error === "No leads found with the provided filters"){
             
         }
     })

} 

useEffect(()=>{

    callBackResponse();

  },[]);

  const columns =[
    {
      title: 'Lead ID',
      dataIndex: 'id',
      width: 100,
      render: (id, record) => (
        <span
         // style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }} // Optional styling
         // onClick={() => handleClick(record)} // Call handleClick directly
        >
          {id}
        </span>
      )
    },
    {
       // key:'lead_date',
        title : 'Lead Date',
       // dataIndex : 'lead_date',
       render: (record) => { return (<p>{moment.utc(record.attributes.created_at).format("DD-MM-YYYY")}</p>)},
       //render: (record) => record.attributes.created_at,
        width: 150
    },
    {
      title : 'Survey Agent Name',
      width: 150,
      render: (record) => "XXXXX",
      
   },
    {
      title : 'Quality Agent Name',
      width: 150,
      render: (record) => "XXXXX",
  }, 
  {
      title : 'Sales Agent Name',
      width: 150,
      render: (record) => "XXXXX",
  }, 
  {
    title : 'Distribution Date',
    width: 150,
    render: (record) => "XXXXX",
  },
 
    {
      //  key: 'attributes.business_name',
        title : 'Business Name',
       // dataIndex :'attributes.business_name',
        width: 150,
        render: (record) => "XXXXX",
        //render: business_name => business_name,
    },
    {
      //  key:'customer_name',
        title : 'Customer Name',
        //dataIndex : 'customer_name',
        render: (record) => "XXXXX",
        width: 150
    },
    {
       // key:'billing_address',
        title : 'Billing Address',
      //  dataIndex : 'billing_address',
      render: (record) =>"XXXXX",
        width: 150,
    },
    {
      //  key:'billing_postcode',
        title : 'Billing Postcode',
        render: (record) => "XXXXX",
      //  dataIndex : 'billing_postcode',
        width: 150,
    },
    {
       // key:'contact_number',
        title : 'Contact Number',
        render: (record) => "XXXXX",
      //  dataIndex : 'contact_number',
        width: 150,
    },
    {
       // key:'email_address',
        title : 'Email Address',
        render: (record) => "XXXXX",
       // dataIndex : 'email_address',
        width: 150,
    },
    {
       // key:'product_id',
        title : 'Product',
       // dataIndex : 'product_id', 
       render: (record) =>"XXXXX",
        width: 150
    },
    {
        //key:'elec_current_supplier',
        title : 'Elec Current Supplier',
     //   dataIndex : 'elec_current_supplier',
        render: (record) => "XXXXX",
        width: 150
    },
    {
        //key:'elec_current_supplier',
        title : 'Gas Current Supplier',
     //   dataIndex : 'elec_current_supplier',
        render: (record) => "XXXXX",
        width: 150
    },
    {
        // key:'elec_account_number',
         title : 'Gas Account Number',
         render: (record) => "XXXXX",
         //dataIndex : 'elec_account_number',
         width: 150
     },
    {
       // key:'elec_account_number',
        title : 'Elec Account Number',
        render: (record) => "XXXXX",
        //dataIndex : 'elec_account_number',
        width: 150
    },
    {
       // key:'elec_supply_number',
        title : 'Supply Number',
       // dataIndex : 'elec_supply_number',
       render: (record) =>"XXXXX",
        width: 150
    },
    {
      //  key:'gas_mpr',
        title : 'MPR Number',
        render: (record) => "XXXXX",
        //dataIndex : 'gas_mpr',
        width: 150
    },
    {
      //  key:'elec_msn',
    
        title : 'Electric MSN',
        render: (record) => "XXXXX",
        width: 150
       // dataIndex : 'elec_msn'
    },
    {
      //  key:'gas_msn',
        title : 'Gas MSN',
        render: (record) => "XXXXX",
      //  dataIndex : 'gas_msn',
        width: 150
    },
    {
        //key:'elec_contract_end_date',
        title : 'Electric Contract End Date',
        render: (record) => "XXXXX",
       // dataIndex : 'elec_contract_end_date',
        width: 150
    },
    {
      //  key:'gas_contract_end_date',
        title : 'Gas Contract End Date',
        render: (record) => "XXXXX",
      //  dataIndex : 'gas_contract_end_date',
        width: 150
    },
    {
        //key:'elec_eac',
        title : 'Electric EAC',
        render: (record) => "XXXXX",
        //dataIndex : 'elec_eac',
        width: 150
    },
    {
        //key:'gas_eac',
        title : 'Gas EAC',
        render: (record) => "XXXXX",
        //dataIndex : 'gas_eac',
        width: 150
    },
      
  {
   // key:'gas_billing_amount',
    title : 'Gas Billing Amount',
  //  dataIndex : 'gas_billing_amount',
  render: (record) => "XXXXX",
    width: 150
},
{
    //key:'gas_billing_amount',
    title : 'Electric Billing Amount',
    render: (record) => "XXXXX",
   // dataIndex : 'elec_billing_amount',
    width: 150
},
{
  //key:'gas_billing_amount',
  title : 'Electric Billing Frequncy',
  render: (record) => "XXXXX",
 // render: (record) => record.attributes.electricity.billing_frequency,
 // dataIndex : 'elec_billing_amount',
  width: 150
},
{
    //key:'gas_metertype',
    title : 'Gas Meter type',
    render: (record) => "XXXXX",
    //dataIndex : 'gas_metertype',
    //render: (record) => record.relations.gas.name,
    width: 150
},
{
    //key:'gas_metertype',
    title : 'Electricity Meter type',
    render: (record) => "XXXXX",
    //dataIndex : 'gas_metertype',
   // render: (record) => record.relations.electricity.name,
    width: 150
},
{
    //key:'gas_standing_charge',
    title : 'Gas Standing Charge',
    render: (record) => "XXXXX",
   // dataIndex : 'gas_standing_charge',
    width: 150
},
{
    //key:'gas_standing_charge',
    title : 'Electric Standing Charge',
    render: (record) => "XXXXX",
   // dataIndex : 'gas_standing_charge',
    width: 150
},
{
   // key:'gas_unit_rate',
    title : 'Gas Unit Rate',
    render: (record) => "XXXXX",
    //dataIndex : 'gas_unit_rate',
    width: 150
},
{
    // key:'gas_unit_rate',
     title : 'Electric Unit Rate',
     render: (record) => "XXXXX",
     //dataIndex : 'gas_unit_rate',
     width: 150
 },
{
   // key:'elec_night_rate',
    title : 'Night Rate',
    render: (record) => "XXXXX",
    //dataIndex : 'elec_night_rate',
    width: 150
},
{
    //key:'elec_eve_weekend',
    title : 'Eve Weekend',
    render: (record) => "XXXXX",
    //dataIndex : 'elec_eve_weekend',
    width: 150
},
{
  //  key:'elec_capacity_charge',
    title : 'Capacity Charge',
    render: (record) => "XXXXX",
  //  dataIndex : 'elec_capacity_charge',
    width: 150
},
{
  //  key:'elec_fit_charge',
    title : 'FIT Charge',
    render: (record) => "XXXXX",
   // dataIndex : 'elec_fit_charge',
    width: 150
},
{
  //  key:'lead_status_list_id',
    title : 'Lead Status',
    render: (record) => "XXXXX",
 //   dataIndex : 'lead_status_list_id',
    width: 150
},
{
  //  key:'lead_status_list_id',
    title : 'Call Back Date',
    render: (record) => "XXXXX",
 //   dataIndex : 'lead_status_list_id',
    width: 150
},
// {
//     key:'agent_feedback',
//     title : 'Agent Feedback',
//     dataIndex : 'agent_feedback',
//     render: (record) => "XXXXX",
//     width: 150
// }

]
    return(
    <div className='callbacktable'>
         <Divider variant="dotted" style={{ borderColor: '#7cb305' }}>Details of Validated Low EAC Leads of Survey</Divider>
        <header className='callbacktable-header'>
            {/* {
                <p>dataSource: {[dataSource]}</p>
            } */}
       <Table columns={columns}
    //   bordered
     //  title={() => 'Validated Low EAC Data For Survey Agent'}
        dataSource={dataSource
        //    dataSource.map((curData) => {
        //    const {agent_id} = curData;
        //    const {business_name,billing_address} = curData.attributes;
           
        //    })
        }
        pagination={{ pageSize: 100 }}
       scroll={{ y: 500 }}
       
       onRow={(record, rowIndex) => {
        return {
        
          handleClick: event => {
            
            //handleClick(record);
          }, 
         
        };
      }}
      >
       </Table>
        </header>
    </div>
    );
}

export default SurveyValidatedLowEAC;